import { useState, useEffect } from 'react';
import * as accountActions from 'store/account/actions';

import { useSelector } from 'react-redux';
import { useActions } from 'utils/hooks';
import { selectIsAuthenticated } from 'store/auth/selectors';
// import { selectAccountId } from 'store/account/selectors';

import useRouter from 'use-react-router';
import Sidebar from './sidebar';

const ContentWrapper = ({ children, routes }) => {
  const [appLayout, setAppLayout] = useState(false);
  const [getAccount] = useActions([accountActions.getAccount]);

  const { location } = useRouter();

  const authenticated = useSelector(selectIsAuthenticated);
  // const accountId = useSelector(selectAccountId);

  useEffect(() => {
    if (authenticated) {
      getAccount();
    }
  }, [authenticated]);

  useEffect(() => {
    if (!authenticated && appLayout) {
      setAppLayout(false);
    }
  }, [authenticated, appLayout]);

  useEffect(() => {
    if (authenticated) {
      const activeRoute = routes.find(route => {
        const parts = location.pathname.split('/');
        return (typeof route.path === 'string' ? [route.path] : route.path).some(path =>
          path.startsWith(`/${parts[1]}${parts[2] ? `/` : ''}`)
        );
      });

      if (activeRoute && activeRoute.app) {
        setAppLayout(true);
      } else {
        setAppLayout(false);
      }
    } else {
      setAppLayout(false);
    }
  }, [authenticated, location.pathname]);

  return (
    <div className="content-wrapper">
      {appLayout && <Sidebar />}
      {children}
    </div>
  );
};

export default ContentWrapper;
